import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type GrowthProps = Omit<BusinessIconImageProps, 'color' | 'secondaryColor' | 'strokeWidth'>;

const Growth = ({ size = 24, width, height, alt = '', style, ...props }: GrowthProps) =>
  h(
    'svg',
    {
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      style,
      ...props,
    },
    [
      h(
        'rect',
        {
          width: '24',
          height: '24',
          rx: '4',
          fill: 'url(#paint0_linear_722_9559)',
        },
      ),
      h(
        'rect',
        {
          x: '0.25',
          y: '0.25',
          width: '23.5',
          height: '23.5',
          rx: '3.75',
          stroke: 'url(#paint1_linear_722_9559)',
          "stroke-opacity": '0.3',
          "stroke-width": '0.5',
          "stroke-linecap": 'round',
        },
      ),
      h(
        'path',
        {
          d: 'M11.7121 5.035C11.9247 4.98831 12.0747 4.98836 12.2873 5.035C12.5016 5.08208 12.7512 5.23137 13.2492 5.53011C14.345 6.18749 15.5074 6.75375 16.7121 7.17562C17.2782 7.37385 17.5611 7.47313 17.756 7.64339C17.9232 7.78942 18.0619 7.99115 18.1369 8.20003C18.2243 8.44354 18.216 8.67256 18.1994 9.12972C18.1519 10.4316 17.9166 12.3669 17.0578 14.1131C15.9252 16.4159 14.0332 17.9266 12.9123 18.6707C12.6664 18.8339 12.5434 18.9162 12.3117 18.9715C12.1511 19.0098 11.8495 19.0098 11.6886 18.9715C11.4568 18.9162 11.3331 18.834 11.0871 18.6707C9.9662 17.9266 8.07511 16.4158 6.94255 14.1131C6.08373 12.3669 5.84841 10.4316 5.80094 9.12972C5.78428 8.67252 5.77604 8.44356 5.86344 8.20003C5.93842 7.9913 6.07633 7.78938 6.24333 7.64339C6.43828 7.47311 6.72204 7.3739 7.28825 7.17562C8.4929 6.75375 9.65539 6.18747 10.7511 5.53011C11.2489 5.2315 11.4978 5.08208 11.7121 5.035ZM10.4484 14.2733C10.2242 14.2733 10.0541 14.4752 10.092 14.6961C10.1218 14.8696 10.2723 14.9969 10.4484 14.9969H13.5549C13.7307 14.9965 13.8815 14.8695 13.9113 14.6961C13.949 14.4755 13.7786 14.2738 13.5549 14.2733H10.4484ZM12.0002 8.99203C11.6774 8.99212 11.4162 9.25417 11.4162 9.57699C11.4163 9.83106 11.5783 10.0473 11.8049 10.1278L11.0978 12.036C11.0531 12.1568 10.8944 12.1832 10.8127 12.0838L9.32145 10.2567C9.43106 10.1505 9.49911 10.0014 9.49919 9.83675C9.49919 9.51415 9.23769 9.25224 8.9152 9.25179C8.59233 9.25179 8.33024 9.51388 8.33024 9.83675C8.33039 10.1595 8.59242 10.4207 8.9152 10.4207C8.94858 10.4207 8.982 10.4183 9.01383 10.4129L9.88981 13.5291C9.95055 13.7449 10.1481 13.8944 10.3722 13.8944H13.63C13.854 13.8941 14.0509 13.7448 14.1115 13.5291L14.9875 10.4129C15.0193 10.4183 15.0528 10.4207 15.0861 10.4207C15.4085 10.4203 15.6699 10.1592 15.6701 9.83675C15.6701 9.51414 15.4086 9.25221 15.0861 9.25179C14.7632 9.25179 14.5011 9.51388 14.5011 9.83675C14.5012 10.0017 14.5699 10.1504 14.6799 10.2567L13.1896 12.0838C13.1081 12.1837 12.9484 12.1568 12.9035 12.036L12.1965 10.1278C12.4226 10.0471 12.585 9.83079 12.5851 9.57699C12.5851 9.25427 12.3228 8.99229 12.0002 8.99203Z',
          fill: 'url(#paint2_linear_722_9559)',
        },
      ),
      h(
        'defs',
        {
        },
        [
          h(
            'linearGradient',
            {
              id: 'paint0_linear_722_9559',
              x1: '-18.2374',
              y1: '-57.7414',
              x2: '66.435',
              y2: '-60.9184',
              gradientUnits: 'userSpaceOnUse',
            },
            [
              h(
                'stop',
                {
                  offset: '1',
                  "stop-color": '#F7CEB0',
                  "stop-opacity": '0.3',
                },
              ),
            ],
          ),
          h(
            'linearGradient',
            {
              id: 'paint1_linear_722_9559',
              x1: '-0.503001',
              y1: '6.71775',
              x2: '24.8358',
              y2: '7.15595',
              gradientUnits: 'userSpaceOnUse',
            },
            [
              h(
                'stop',
                {
                  offset: '1',
                  "stop-color": '#F9A789',
                },
              ),
            ],
          ),
          h(
            'linearGradient',
            {
              id: 'paint2_linear_722_9559',
              x1: '18.2098',
              y1: '5.66924',
              x2: '12',
              y2: '19',
              gradientUnits: 'userSpaceOnUse',
            },
            [
              h(
                'stop',
                {
                  "stop-color": '#EF875A',
                },
              ),
              h(
                'stop',
                {
                  offset: '1',
                  "stop-color": '#853A19',
                },
              ),
            ],
          ),
        ],
      ),
    ],
  );

export default Growth;
